import {
  ROOT_SELECTOR,
  controllers,
} from './velzeen-cart-controller-shared.js';
import {
  initializeController,
  coreMethods,
} from './velzeen-cart-controller-core.js';
import { enhancementMethods } from './velzeen-cart-controller-enhancements.js';
import { syncMethods } from './velzeen-cart-controller-sync.js';
import { uiMethods } from './velzeen-cart-controller-ui.js';

class VelzeenCartController {
  /** @param {HTMLElement} root */
  constructor(root) {
    initializeController.call(this, root);
  }
}

for (const methods of [coreMethods, enhancementMethods, syncMethods, uiMethods]) {
  Object.defineProperties(
    VelzeenCartController.prototype,
    Object.getOwnPropertyDescriptors(methods)
  );
}

/** @param {ParentNode} root */
function initialize(root = document) {
  const elements = root instanceof Element && root.matches(ROOT_SELECTOR)
    ? [root]
    : root.querySelectorAll(ROOT_SELECTOR);

  for (const element of elements) {
    if (!(element instanceof HTMLElement) || controllers.has(element)) continue;
    controllers.set(element, new VelzeenCartController(element));
  }
}

initialize();

const observer = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element) initialize(node);
    }
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });
